<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { getDeviceState } from 'src/stores/device-runtime/states';
	//Design system components
	import { Text, CircleAvatar } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	//Helpers
	import { getDeviceAvatarDefaultConfig } from 'src/helpers/device_state_view_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import {
		getCriticalNotifications,
		getNotificationsForDevice,
	} from 'src/helpers/notifications/device_notifications_helper';

	export let device: Device;

	const fullOfflineMessage =
		device.gen == 'GBLE'
			? $format('text_message_device_state_offline_ble', {
					default:
						'Please check the device battery and ensure there are Shelly Bluetooth gateway devices around in.',
				})
			: $format('text_message_device_state_offline', {
					default: 'Please ensure the device is powered on and connected to Wi-Fi.',
				});

	$: notificationsToShow = getNotificationsForDevice(device?.id);
	$: criticalNotifications = getCriticalNotifications(notificationsToShow);

	$: deviceStateStore = getDeviceState(device?.id);
	$: deviceState = $deviceStateStore;
	$: isOffline = deviceState?.type === 0;
</script>

<CircleAvatar
	{...getDeviceAvatarDefaultConfig(device)}
	disabled={isOffline}
	borderStatus={criticalNotifications?.length && isOffline
		? { icon: 'fa-solid fa-shield-exclamation', color: 'color-warning' }
		: null}
/>

<Text class="mb-s text-bold text-center">
	{$format('device_status_offline', {
		default: 'Device is offline',
	})}.
	{#if criticalNotifications.length}
		{capFirstChar(criticalNotifications[0].name)}
		{$format('text_detected', { default: 'detected' })}.
	{/if}
</Text>
<Text class="text-color-muted text-center" styleType="body-small">
	{capFirstChar(fullOfflineMessage)}
</Text>
